import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * DynamicManifest - Switches manifest based on current route
 * This allows Admin and User PWAs to be installed as separate apps
 */
export default function DynamicManifest() {
  const location = useLocation();

  useEffect(() => {
    const manifestLink = document.querySelector('link[rel="manifest"]');
    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    const appleTitleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    
    if (!manifestLink) return;

    const isAdminRoute = location.pathname.startsWith('/admin');
    
    if (isAdminRoute) {
      // Admin PWA configuration
      manifestLink.setAttribute('href', '/manifest-admin.json');
      if (themeColorMeta) themeColorMeta.setAttribute('content', '#f97316'); // Orange for Admin
      if (appleTitleMeta) appleTitleMeta.setAttribute('content', 'Admin PD');
      document.title = 'Admin - Produk Digital';
    } else {
      // User PWA configuration
      manifestLink.setAttribute('href', '/manifest.json');
      if (themeColorMeta) themeColorMeta.setAttribute('content', '#0ea5e9'); // Sky blue for User
      if (appleTitleMeta) appleTitleMeta.setAttribute('content', 'Produk Digital');
      // Only set title if not already set by a page
      if (!document.title || document.title.includes('Admin')) {
        document.title = 'PDAM Payment Online';
      }
    }
  }, [location.pathname]);

  return null; // This component only manages side effects
}
